import colors from './colors'
import React from 'react'

const feedPlaceholder = (width, height, color = colors.grey_2) => {
    return (
        <div
            style={{
                width: width,
                height: height,
                backgroundColor: color,
                boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
            }}
        />
    )
}

export default {
    feedPlaceholder,
}
